import Turbolinks from 'turbolinks';
export default function visit(path){
  let dataTurbolinks = document.body.getAttribute('data-turbolinks')
  if(dataTurbolinks == 'false'){
    window.location = path;
  } else {
    Turbolinks.visit(path);
  }
}
export function pushState(path, state = {}){
  state['turbolinks'] = {}
  window.history.pushState(state, '', path);
}
export function replaceState(path, state = {}){
  state['turbolinks'] = {}
  window.history.replaceState(state, '', path);
}
